import React from 'react';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { ErrorTooltip } from '@retail/components';
import { BaseTextFieldProps, InputAdornment, TextField } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TTransformedValues = TFieldValues
> {
  name: TName;
  control: Control<TFieldValues, any, TTransformedValues>;
  size?: BaseTextFieldProps['size'];
  sx?: BaseTextFieldProps['sx'];
  disabled?: BaseTextFieldProps['disabled'];
}

export const PriceInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TTransformedValues = TFieldValues
>({
  name,
  control,
  ...rest
}: Props<TFieldValues, TName, TTransformedValues>) => {
  const t = useProductsTFunction();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <ErrorTooltip title={fieldState.error?.message} arrow>
          <TextField
            {...field}
            error={!!fieldState.error}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    {t('products.prices.price', { price: '' })}
                  </InputAdornment>
                ),
              },
            }}
            {...rest}
          />
        </ErrorTooltip>
      )}
    />
  );
};
